import { render, staticRenderFns } from "./dftj.vue?vue&type=template&id=227964c2&"
import script from "./dftj.vue?vue&type=script&lang=js&"
export * from "./dftj.vue?vue&type=script&lang=js&"
import style0 from "./dftj.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports